import { render, staticRenderFns } from "./AuthorizationPaymentWarning.vue?vue&type=template&id=70c7c9e4"
import script from "./AuthorizationPaymentWarning.vue?vue&type=script&lang=js"
export * from "./AuthorizationPaymentWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports